var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time_download"},[_c('div',{staticClass:"leftwrapper"},[_c('Icon',{staticClass:"clock",attrs:{"type":"ios-clock-outline"}}),_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.time))+"  "+_vm._s(_vm.utc))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }